"use client";

import React from "react";
import { Briefcase, TrendingUp, Settings2, Cpu, GraduationCap, ChartLine, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Website Development",
  description: "High-end, performance-driven digital experiences designed to convert visitors into loyal brand advocates.",
  icon: Briefcase,
  href: "/ServicesPage"
}, {
  title: "Social Media Management",
  description: "Strategic growth and community engagement across platforms to amplify your digital footprint and reach.",
  icon: TrendingUp,
  href: "/ServicesPage"
}, {
  title: "Branding & Identity",
  description: "Crafting unique visual identities and narratives that resonate with your audience and define your market position.",
  icon: Settings2,
  href: "/ServicesPage"
}, {
  title: "Personal Branding",
  description: "Tailored positioning for athletes and influencers to build authority, trust, and monetize their influence.",
  icon: Cpu,
  href: "/ServicesPage"
}, {
  title: "Content Creation",
  description: "Premium short-form video and cinematic visual assets designed to capture attention in a fast-paced world.",
  icon: GraduationCap,
  href: "/ServicesPage"
}, {
  title: "Digital Strategy",
  description: "Data-led roadmaps that align your vision with actionable growth and long-term brand scalability.",
  icon: ChartLine,
  href: "/ServicesPage"
}];
export default function SolutionEcosystem() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="2510" id="core-capabilities" className="dark bg-background py-24 relative overflow-hidden" ref={ref}>
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] bg-secondary/10 rounded-full blur-3xl opacity-20" />
        <div className="absolute bottom-[-10%] left-[-5%] w-[500px] h-[500px] bg-secondary/10 rounded-full blur-3xl opacity-20" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        {}
        <div className={`mb-16 max-w-3xl transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <h2 className="text-5xl md:text-7xl font-black text-foreground mb-6 tracking-tighter uppercase">
            Core Capabilities
          </h2>
          <Separator className="w-24 h-1 bg-secondary mb-6" />
          <p className="text-xl text-muted-foreground max-w-2xl font-light leading-relaxed">
            Moondos Media delivers a suite of elite creative services designed to build strong online identities and grow your audience through cinematic digital presence.
          </p>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {services.map((service, index) => <div key={index} data-index={index} className={`transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} style={{
          transitionDelay: `${index * 100}ms`
        }}>
              <Link to={service.href} className="block h-full group outline-none">
                <Card className="h-full bg-background/40 backdrop-blur-xl border-white/10 hover:border-secondary/50 transition-all duration-500 overflow-hidden relative group-hover:shadow-[0_0_40px_-15px_var(--color-secondary)] group-focus-visible:ring-1 group-focus-visible:ring-secondary rounded-lg">
                  <CardHeader className="pb-4">
                    <div className="mb-4 p-3 w-fit rounded-sm bg-secondary/10 text-secondary group-hover:bg-secondary group-hover:text-secondary-foreground transition-all duration-300">
                      <service.icon className="w-8 h-8" strokeWidth={1} />
                    </div>
                    <CardTitle className="text-2xl font-bold text-foreground group-hover:text-secondary transition-colors duration-300 tracking-tight">
                      {service.title}
                    </CardTitle>
                  </CardHeader>
                  
                  <CardContent className="relative pb-16">
                    <CardDescription className="text-muted-foreground text-lg leading-relaxed font-light">
                      {service.description}
                    </CardDescription>
                    
                    {}
                    <div className="absolute bottom-6 left-6 flex items-center gap-2 text-secondary font-mono text-xs uppercase tracking-widest opacity-0 translate-y-4 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300 ease-out">
                      <span>View Project Scope</span>
                      <ArrowRight className="w-4 h-4" />
                    </div>
                  </CardContent>
                  
                  {}
                  <div className="absolute inset-0 bg-gradient-to-t from-secondary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
                </Card>
              </Link>
            </div>)}
        </div>

        {}
        <div className="mt-12 text-center md:hidden">
          <Button asChild size="lg" className="w-full sm:w-auto bg-secondary text-background hover:bg-secondary/90 transition-colors duration-300 rounded-lg uppercase tracking-widest font-bold">
            <Link to="/ServicesPage">
              Explore All Services
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}